import React from 'react';
import CatchErrors from "../../../Utility/CatchErrors";
import GenericAddressWidget from "./GenericAddressWidget";

/**
 * 2025-03 - wrap each Smarty component, and fall back
 * on AddressTextWidget if smarty is disabled
 *
 * @param component
 * @param alternative
 * @param props
 * @returns {Element}
 * @constructor
 */
export default function SmartyLimiter({
  component,
  alternative=GenericAddressWidget,
  cartConfig,
  ...props}) {

  // 2025-07 - require license key in cartConfig
  const useSmarty = !(cartConfig?.disableSmarty) && !!cartConfig?.smartyLicense;

  const COMPONENT = useSmarty ? component : alternative;

  return <CatchErrors>
    <COMPONENT {...props} cartConfig={cartConfig} />
  </CatchErrors>
}
